<router-outlet></router-outlet>
<ng-container *ngIf="errors$ | async as errors">
  <div class="errors" *ngIf="errors.length > 0">
    <div class="error" *ngFor="let error of errors">{{ error.message }}</div>
  </div>
</ng-container>
